import { IconButton } from "@mui/material";
import { IKeyVal } from "../shared/Password";
import { CopyAllOutlined } from "@mui/icons-material";
import Utils from "../libs/Utils";
import { useSnackbar } from "../libs/dialog/SnackbarProvider";
import { useState } from "react";

export default function PropertyList(props:{data:IKeyVal}) {
    const [show,setShow] = useState<boolean>(false)
    const {data} = props
    const {setSnackbar} = useSnackbar()
    const onCopy = () => {
        Utils.clipboard(data.val)
        setSnackbar("Copied");
    }
    return <>
        <label>{data.key}</label>
        <div onClick={() => setShow(!show)}>{show ? data.val : "*********"}</div>
        <IconButton onClick={onCopy}><CopyAllOutlined/></IconButton>
    </>
}